import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from 'components/commons/Icon';

import { getLocaleUrlPath } from 'utils';
import { InfoBlockWrapper, InfoBlockItem, IconWrapper } from './styles';

const items = [
  {
    id: 'infoBlock.question',
    icon: 'questionIcon',
    href: 'currency/mb/about/',
  },
  {
    id: 'infoBlock.rates',
    icon: 'ratesIcon',
    href: 'currency/auction/usd/buy/kiev/',
  },
  {
    id: 'infoBlock.info',
    icon: 'infoIcon',
    href: 'currency/informers/#informers-mb',
  },
  {
    id: 'infoBlock.api',
    icon: 'apiIcon',
    href: 'developers/api/',
  },
];

const archiveItemIds = [
  'infoBlock.question',
  'infoBlock.info',
  'infoBlock.api',
];

const InfoBlock = ({ variant }) => {
  const { locale } = useIntl();
  const isArchive = variant === 'archive';
  const visibleItems = isArchive
    ? items.filter(({ id }) => archiveItemIds.includes(id))
    : items;

  return (
    <InfoBlockWrapper>
      {visibleItems.map(({ id, icon, href }) => (
        <InfoBlockItem
          href={`${process.env.APP_MINFIN_API_DOMAIN}${getLocaleUrlPath(
            locale
          )}/${href}`}
          target="_blank"
          key={id}
        >
          <IconWrapper>
            <Icon name={icon} />
          </IconWrapper>

          <FormattedMessage id={id} />
        </InfoBlockItem>
      ))}
    </InfoBlockWrapper>
  );
};

InfoBlock.propTypes = {
  variant: PropTypes.oneOf(['default', 'archive']),
};

InfoBlock.defaultProps = {
  variant: 'default',
};

export default InfoBlock;
